export default __webpack_public_path__ + "static/media/Spirituality.9a85321d.webp";